// src/components/SupportDialog.tsx
import React, { useEffect, useRef, useState } from 'react';

interface SupportDialogProps {
    onClose: () => void;
}

export const SupportDialog: React.FC<SupportDialogProps> = ({ onClose }) => {
    const [isClosing, setIsClosing] = useState(false);
    const phoneNumber = '+992111100169';
    const formattedPhone = '+992 11 110 0169';
    const telegramUsername = 'Faiziddin2001';
    const instagramUrl = 'https://www.instagram.com/ruyo_market_1?utm_source=qr&igsh=MXVmYmxjZTBpMzZmbg==';
    const dialogRef = useRef<HTMLDivElement>(null);
    const startYRef = useRef<number>(0);

    const openWhatsApp = () => {
        window.open(`https://wa.me/${phoneNumber.replace(/[^0-9]/g, '')}`, '_blank');
    };

    const openTelegram = () => {
        window.open(`https://t.me/${telegramUsername}`, '_blank');
    };

    const openInstagram = () => {
        window.open(instagramUrl, '_blank');
    };

    const callPhone = () => {
        window.location.href = `tel:${phoneNumber}`;
    };

    const handleClose = () => {
        setIsClosing(true);
        setTimeout(() => {
            onClose();
        }, 300);
    };

    const handleOverlayClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            handleClose();
        }
    };

    // Закрытие по свайпу вниз
    const handleTouchStart = (e: React.TouchEvent) => {
        startYRef.current = e.touches[0].clientY;
    };

    const handleTouchMove = (e: React.TouchEvent) => {
        const currentY = e.touches[0].clientY;
        const diff = currentY - startYRef.current;

        // Если свайп вниз больше 50px
        if (diff > 50 && dialogRef.current) {
            handleClose();
        }
    };

    // Закрытие по кнопке "Назад"
    useEffect(() => {
        const handleBackButton = () => {
            handleClose();
        };

        window.addEventListener('popstate', handleBackButton);
        window.history.pushState(null, '', window.location.href);

        return () => {
            window.removeEventListener('popstate', handleBackButton);
        };
    }, []);

    return (
        <div
            className={`support-overlay ${isClosing ? 'closing' : ''}`}
            onClick={handleOverlayClick}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
        >
            <div className={`support-content ${isClosing ? 'closing' : ''}`} ref={dialogRef}>
                <button className="support-close" onClick={handleClose}>
                    ✕
                </button>

                <div className="support-icon">
                    🛠️
                </div>

                <h3>Техническая поддержка</h3>

                <div className="support-phone">
                    <div className="phone-number" onClick={callPhone}>
                        📞 {formattedPhone}
                    </div>
                    <div className="phone-hint">Нажмите чтобы позвонить</div>
                </div>

                <div className="support-divider">
                    <span>Свяжитесь с нами</span>
                </div>

                <div className="support-buttons">
                    <button className="support-btn whatsapp" onClick={openWhatsApp}>
                        <span className="btn-icon">💬</span>
                        WhatsApp
                    </button>
                    <button className="support-btn telegram" onClick={openTelegram}>
                        <span className="btn-icon">✈️</span>
                        Telegram
                    </button>
                    <button className="support-btn instagram" onClick={openInstagram}>
                        <span className="btn-icon">📷</span>
                        Instagram
                    </button>
                </div>

                <div className="support-note">
                    Мы ответим вам в ближайшее время
                </div>
            </div>
        </div>
    );
};

export default SupportDialog;